import { Image } from 'expo-image';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import type { MenuItem } from '@/types/menu-item';
import { imageUrl } from '@/utils/image-url';

interface MenuItemResultItemProps {
  menuItem: MenuItem;
  onPress: (id: string) => void;
}

export function MenuItemResultItem({ menuItem, onPress }: MenuItemResultItemProps) {
  const coverPhoto = menuItem.coverPhotoR2Key ? imageUrl(menuItem.coverPhotoR2Key, 'thumbnail') : null;

  return (
    <Pressable
      onPress={() => onPress(menuItem.id)}
      className="mb-4 p-4 rounded-lg bg-surface border border-border"
      style={{ borderCurve: 'continuous' }}
    >
      <View className="flex-row">
        <View className="w-20 h-20 rounded-lg mr-3 overflow-hidden" style={{ borderCurve: 'continuous' }}>
          {coverPhoto ? (
            <Image
              source={{ uri: coverPhoto }}
              style={{ width: '100%', height: '100%' }}
              contentFit="cover"
              accessibilityLabel={`Photo of ${menuItem.name}`}
            />
          ) : (
            <View className="w-20 h-20 items-center justify-center bg-surface-secondary">
              <Ionicons name="restaurant" size={32} className="text-muted-foreground" />
            </View>
          )}
        </View>

        <View className="flex-1">
          <Text className="text-lg font-semibold mb-1 text-foreground">
            {menuItem.name}
          </Text>
          {menuItem.businessName && (
            <Text className="text-sm mb-1 text-muted-foreground">
              {menuItem.businessName}
            </Text>
          )}
          {menuItem.description && (
            <Text className="text-sm text-muted-foreground" numberOfLines={2}>
              {menuItem.description}
            </Text>
          )}
        </View>
      </View>
    </Pressable>
  );
}
